// Only the SVGs used by interactive Vue components are bundled.
import arrowRightLine from "remixicon/icons/Arrows/arrow-right-line.svg?inline-icon";
import arrowRightUpLine from "remixicon/icons/Arrows/arrow-right-up-line.svg?inline-icon";
import checkboxCircleLine from "remixicon/icons/System/checkbox-circle-line.svg?inline-icon";
import clipboardLine from "remixicon/icons/Document/clipboard-line.svg?inline-icon";
import closeLine from "remixicon/icons/System/close-line.svg?inline-icon";
import facebookBoxFill from "remixicon/icons/Logos/facebook-box-fill.svg?inline-icon";
import mailLine from "remixicon/icons/Business/mail-line.svg?inline-icon";
import rulerLine from "remixicon/icons/Design/ruler-line.svg?inline-icon";
import shareForwardLine from "remixicon/icons/System/share-forward-line.svg?inline-icon";
import shieldCheckLine from "remixicon/icons/System/shield-check-line.svg?inline-icon";
import truckLine from "remixicon/icons/Map/truck-line.svg?inline-icon";
import weightLine from "remixicon/icons/Others/weight-line.svg?inline-icon";
import whatsappLine from "remixicon/icons/Logos/whatsapp-line.svg?inline-icon";

export default {
    "ri-arrow-right-line": arrowRightLine,
    "ri-arrow-right-up-line": arrowRightUpLine,
    "ri-checkbox-circle-line": checkboxCircleLine,
    "ri-clipboard-line": clipboardLine,
    "ri-close-line": closeLine,
    "ri-facebook-box-fill": facebookBoxFill,
    "ri-mail-line": mailLine,
    "ri-ruler-line": rulerLine,
    "ri-share-forward-line": shareForwardLine,
    "ri-shield-check-line": shieldCheckLine,
    "ri-truck-line": truckLine,
    "ri-weight-line": weightLine,
    "ri-whatsapp-line": whatsappLine,
};
